module.exports = __webpack_public_path__ + "img/home-howitworks-bg.edc9264e.svg";